import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { InformationOutline } from '@patrianna-icons/material-icons'
import Link from 'next/link'
import type { MouseEvent } from 'react'

import classes from '../styles.module.scss'

type Props = {
  title: string
  infoUrl: string
}

export default function MoreInfoBtn({ title, infoUrl }: Props) {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()

    nextTick().then(() => {
      trackEvent('game_tile_i_icon_click')
    })
  }

  return (
    <div className={classes.moreInfoBtn}>
      <Link
        href={infoUrl}
        prefetch={false}
        className={classes.moreInfoBtnIcon}
        onClick={onClick}
        title={title}
        aria-label={`More information about ${title}`}
      >
        <InformationOutline />
      </Link>
    </div>
  )
}
